export const getRevokeMerchantAccessHelpingText = (
  email: string,
  merchantCount: number,
): string => {
  const base = `This removes direct access for ${email} at this merchant.`;
  if (merchantCount > 1) {
    return `${base} They will keep their portal account and other merchant assignments.`;
  }
  return base;
};

export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  if (error && typeof error === 'object' && 'data' in error) {
    const message = (error as { data?: { message?: string } }).data?.message;
    if (message) {
      return message;
    }
  }
  return fallback;
};
